import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Export from './Export';
import Mentees from './index';
import MenteeDetail from './[id]';
import EditInformationPage from './[id]/EditInformation';
import ReviewPage from './[id]/interviews/[id]';
import AssociatePage from './[id]/Mentoring/AssociatePage';

const MenteesRoutes: FC = () => {
  return (
    <Routes>
      <Route path="" element={<Mentees />} />
      <Route path="/export" element={<Export />} />
      <Route path="/:id/interviews/:interviewId" element={<ReviewPage />} />
      <Route path="/:id/*" element={<MenteeDetail />} />
      <Route path="/:id/mentoring/associate" element={<AssociatePage />} />
      <Route path="/:id/edit-information" element={<EditInformationPage />} />
    </Routes>
  );
};

export default MenteesRoutes;
